import HeroDetails from './HeroDetails';

export default HeroDetails;
